
// events.js
import EventEmitter from 'events';

export const undoEvent = new EventEmitter();
export const redoEvent = new EventEmitter();
export const loginEvent = new EventEmitter();
export const multiDragEvent = new EventEmitter();
